import { Paging as ElasticPaging, withSearch } from '@elastic/react-search-ui';
import { css } from '@linaria/core';
import Paging from './Paging';
import { useLayoutMode } from './Layout';

const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
`;
const message = css`
  font-weight: 600;
`;

/**
 * Custom Paging component that enforces the API's 10,000 result limit and informs users
 * when they've reached this limit. Without this functionality, users might get an incorrect
 * idea about the amount of data available (e.g. 50 records across 100 pages suggests 5000
 * records when there may be many more).
 */
function PagingRealistic({
  totalPages,
  current,
  resultsPerPage,
  totalResults,
}) {
  const { layoutMode } = useLayoutMode();

  if (layoutMode === 'map') {
    return null;
  }

  // The API has a 10,000 records limit
  const MAX_RESULTS = 10000;
  const maxAllowedPages = Math.floor(MAX_RESULTS / resultsPerPage);
  const effectiveTotalPages = Math.min(totalPages, maxAllowedPages);
  const isOnLastAllowedPage = current === effectiveTotalPages;
  const isLimitedByMaxResults =
    totalPages > maxAllowedPages || totalResults > MAX_RESULTS;

  function getMaxResults() {
    const resultsShown = Math.min(
      current * resultsPerPage,
      MAX_RESULTS,
      totalResults,
    );
    return resultsShown.toLocaleString('en-US', {
      maximumFractionDigits: 0,
    });
  }

  const PagingWithLimit = props => (
    <Paging {...props} effectiveTotalPages={effectiveTotalPages} />
  );

  return (
    <div className={wrapper}>
      <ElasticPaging view={PagingWithLimit} />

      {isOnLastAllowedPage && isLimitedByMaxResults && (
        <div
          className={message}
        >{`Showing the first ${getMaxResults()} records, please apply filters to access further records.`}</div>
      )}
    </div>
  );
}

export default withSearch(
  ({ totalPages, resultsPerPage, totalResults, current }) => ({
    totalPages,
    resultsPerPage,
    totalResults,
    current,
  }),
)(PagingRealistic);
